import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Stack,
    Typography,
    Button,
    CircularProgress
} from '@mui/material';
import { grey } from '@mui/material/colors';
import {ContentCopy, Print} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {useCommonItems} from "../../../../contexts/CommonItensProvider";
import {listaProdutos} from "../../epis/products/configs/functions";
import {listaUsuariosFilter} from "../../management/people/configs/functions";


export const RequestErrorDetailModal = ({ open, onClose, requestErrorsDetails }) => {
    const { exibirAlerta } = useCommonItems();
    const [detalhes, setDetalhes] = useState(null);

    const formattedData = requestErrorsDetails ? JSON.stringify(requestErrorsDetails, null, 2) : "";

    const handleCopy = () => {
        navigator.clipboard.writeText(formattedData);
        exibirAlerta('Sucesso', 'Requisição copiada com sucesso', 'success');
    };

    const getJsonDetails = async (requestInfo) => {
        const obj = JSON.parse(requestInfo);
        const resultado = {};

        for (const [key, value] of Object.entries(obj)) {
            if (key.startsWith('id_')) {
                const tipo = key.slice(3);

                try {
                    switch (tipo) {
                        case 'produto': {
                            const produto = await listaProdutos({id: value});
                            resultado['Produto'] = produto.data?.data[0]?.nome ?? 'Desconhecido';
                            break;
                        }
                        case 'pessoa': {
                            const pessoa = await listaUsuariosFilter({id: value});
                            resultado['Pessoa'] = pessoa.data?.data[0]?.nome ?? 'Desconhecido';
                            break;
                        }
                        default:
                            break;
                    }
                } catch (error) {
                    console.error(`Erro ao buscar ${tipo} com id ${value}:`, error);
                }
            }
        }

        return Object.keys(resultado).length > 0 ? resultado : null;
    };

    useEffect(() => {
        if (requestErrorsDetails && open) {
            getJsonDetails(requestErrorsDetails)
                .then(resultado => setDetalhes(resultado))
                .catch((e) => console.log(e));
        } else {
            setDetalhes(null);
        }
    }, [requestErrorsDetails, open]);

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
                <DialogTitle>Detalhes da Requisição</DialogTitle>

                <Divider />

                <DialogContent>
                    <Typography>Requisição</Typography>
                    {requestErrorsDetails ? (
                        <Stack spacing={2} sx={{ width: "100%", bgcolor: grey[100], p: 2, borderRadius: 2, fontFamily: 'monospace', whiteSpace: 'pre-wrap', overflowX: 'auto' }}>
                            <Typography variant='body2' component='pre' sx={{ m: 0 }}>
                                {formattedData}
                            </Typography>
                        </Stack>
                    ) : (
                        <Typography variant='subtitle1'>Não há dados de requisição para este erro</Typography>
                    )}
                </DialogContent>

                <DialogContent>
                    <Typography>Detalhes</Typography>

                    {detalhes ? (
                        <Stack spacing={2} sx={{ width: '100%', bgcolor: grey[100], p: 2, borderRadius: 2, fontFamily: 'monospace', whiteSpace: 'pre-wrap', overflowX: 'auto' }}>
                            <Typography
                                variant="body2"
                                component="pre"
                                sx={{ m: 0, whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}
                            >
                                {Object.entries(detalhes)
                                    .map(([chave, valor]) => `${chave}: ${valor}`)
                                    .join('\n')}
                            </Typography>
                        </Stack>
                    ) : (
                        <CircularProgress size={20} />
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose} color="background" variant='contained'>
                        Fechar
                    </Button>
                    <Button color="primary" variant="contained" startIcon={<ContentCopy />} onClick={handleCopy}>
                        Copiar
                    </Button>
                </DialogActions>
            </Dialog>


        </>
    );
};
